<!-- import DeviceMeta from "@/pages/Dashboard/Meta/DeviceMeta/DeviceMeta.vue"; -->
<template>
  <v-app>
  <div class="md-layout meta-css">
    <div class="md-layout-item">
      <v-card>
        <v-card-title class="v-card-header-icon md-card-header-green" >
          <div class="card-icon">
            <v-icon>public</v-icon>
          </div>
          <h4 class="title">设备定义</h4>
        </v-card-title>
        <v-card-text ref="mainCardContent">
          <md-toolbar class="md-small md-success">
            <div class="md-toolbar-row">
              <div class="md-toolbar-section-start">
                <md-button class="md-icon-text-button md-success md-sm" @click="showDialog = true">
                  <md-icon>menu</md-icon>打开设备
                </md-button>
                <v-dialog v-model="showDialog" max-width="80%">
                  <OpenSceneForm @handleCancel="showDialog = false"
                    @handleConfirm="handleOpenSceneConfirm" />
                </v-dialog>
              </div>
              <span class="md-title">{{  title  }}</span>
              <div class="md-toolbar-section-end" v-show="form.name">
                <md-button class="md-icon-button md-success" @click="save">
                  <md-icon>save_as</md-icon>
                  <md-tooltip>保存</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-success" @click="update">
                  <md-icon>refresh</md-icon>
                  <md-tooltip>刷新</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-success" @click="setSpacingList('left')">
                  <md-icon>format_indent_decrease</md-icon>
                  <md-tooltip>隐藏/展示左侧栏</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-success" @click="setSpacingList('center')">
                  <md-icon>reorder</md-icon>
                  <md-tooltip>隐藏/展示中间栏</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-success" @click="setSpacingList('right')">
                  <md-icon>format_indent_increase</md-icon>
                  <md-tooltip>隐藏/展示右侧栏</md-tooltip>
                </md-button>
                <md-button @click="fullScreen" class="md-icon-button md-success">
                  <md-icon>fullscreen</md-icon>
                  <md-tooltip>全屏</md-tooltip>
                </md-button>
              </div>
            </div>
          </md-toolbar>
          <Split :style="{
            height: !fullscreen ? 'calc(100vh - 155px - 120px)' : 'calc(100vh - 70px)'
          }">
            <SplitArea :size="getSize().left" :minSize="100">
              <md-field style="margin: 0; margin-top: 5px; margin-left: 12px">
                <md-input type="search" class="mb-3" clearable style="width: 200px" placeholder="搜索" v-model="treeName">
                </md-input>
              </md-field>
              <tree :setting="setting" :nodes="treeDatas" @onCreated="handleCreated" ref="tree" class="md-tree" />
            </SplitArea>
            <SplitArea :size="getSize().center" :minSize="100">
              <ThreeModel id="ThreeModel" ref="ThreeModel" @modelClick="modelClick" @getTree="getTree"
                v-if="showThreeModel" :sceneId="sceneId" :url="sceneUrl" />
            </SplitArea>
            <SplitArea :size="getSize().right">
              <DeviceForm ref="basicInfoForm" :formData="form" :sceneId="sceneId" @hanldeSave="saveTree" />
            </SplitArea>
          </Split>
        </v-card-text>
      </v-card>
    </div>
  </div>
  </v-app>
</template>

<script>
import { findStructAllInfo, saveTreeData } from '@/api/device'
import tree from 'vue-giant-tree'
import { Collapse, ProductCard } from '@/components'
import { Pagination, ThreeModel } from '@/components'
import { listCourse } from '@/api/course'
import { listProject } from '@/api/project'
import Fuse from 'fuse.js'

import { SlideYDownTransition } from 'vue2-transitions'
import { extend } from 'vee-validate'
import { required, required_if, integer, double } from 'vee-validate/dist/rules'
import OpenSceneForm from './Form/OpenSceneForm'
import DeviceForm from './Form/DeviceForm'

extend('required', required)
extend('integer', integer)
extend('double', double)
extend('required_if', required_if)

// 没有与页面有之间关联的数据放在外边，避免监听带来的性能损耗
let uuidObject3DMap = {}
let uuidTreeNodeMap = {}
let ztreeObj = {}

export default {
  name: 'DeviceMeta',
  props: {
    avatar: {
      type: String,
      default: './img/image_placeholder.png'
    }
  },
  provide() {
    return {
      topNode: this
    }
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData
      if (this.searchedData.length > 0) {
        result = this.searchedData
      }
      return result.slice(this.from, this.to)
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total() {
      return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length
    }
  },
  data() {
    return {
      form: {},
      showSpacingList: ['left', 'center', 'right'],
      showThreeModel: true,
      showAddDialog: false,
      fullscreen: false,
      treeDatas: [],
      scenes: [],
      //ztree对象
      ztreeNodes: [],
      //ztree配置，参照ztree官网的配置
      setting: {
        check: {
          //树是否带复选框或者单选框
          enable: true
        },
        data: {
          simpleData: {
            //是否使用简单数据模式
            enable: true,
            //树节点id，一般是后台数据库主键
            idKey: 'id',
            //父级id
            pIdKey: 'pid',
            rootPId: '0'
          }
        },
        //ztree回调函数
        callback: {
          //树选择事件
          onCheck: this.ztreeOnCheck,
          onClick: this.ztreeOnClick
        }
      },
      treeName: '',
      propertyType: '',
      searchQuery: '',
      propsToSearch: ['name'],
      searchedData: [],
      fuseSearch: null,
      sceneId: '',
      checkedSceneId: '',
      //sceneUrl: 'https://metastation.oss-cn-hangzhou.aliyuncs.com/gltf/35kV%E5%BC%80%E5%85%B3%E6%9F%9C.gltf',
      sceneUrl: '',
      sceneMap: {
        '629dfc5fd809c3365b8adf26': 'static/35kV%E5%BC%80%E5%85%B3%E6%9F%9C.gltf',
        '629dfc06d809c3365b8adf17': 'static/110kV-Substation.gltf'
      },
      title: '35KV变电站',
      titleMap: {
        '629dfc5fd809c3365b8adf26': '35KV变电站',
        '629dfc06d809c3365b8adf17': '110KV变电站'
      },
      getStructInfoList: [],
      structInfoMap: {},
      showDialog: false
    }
  },

  components: {
    tree,
    Collapse,
    ProductCard,
    Pagination,
    ThreeModel,
    SlideYDownTransition,
    OpenSceneForm,
    DeviceForm
  },
  methods: {
    async init() {
      const courseResult = await listCourse({ getAll: true, perPage: 500 })
      if (courseResult.code == 200) {
        this.courseList = courseResult.data.rows
      }
    },
    async filterProject(item) {
      const projectResult = await listProject({
        course: item._id,
        perPage: 500
      })
      if (projectResult.code == 200) {
        this.projectList = projectResult.data.rows
        this.projectDisabled = false
      }
    },
    checkScene(modObj) {
      this.checkedSceneId = this.sceneId
      this.sceneUrl = modObj.modFile
      this.title = modObj.name
      this.$nextTick(() => {
        this.$refs.ThreeModel.load()
      })
      this.showDialog = false
    },
    update() {
      this.$router.go(0)
    },
    resetSize() {
      this.showSpacingList = ['left', 'center', 'right']
    },
    setSpacingList(type) {
      let index = this.showSpacingList.indexOf(type)
      if (index > -1) this.showSpacingList.splice(index, 1)
      else this.showSpacingList.push(type)
    },
    getSize() {
      let map = {
        left: 20,
        center: 55,
        right: 25
      }
      console.log(this.showSpacingList)
        ;['left', 'center', 'right'].forEach((v) => {
          if (!this.showSpacingList.includes(v)) {
            map[v] = 0
          }
        })
      if (this.showSpacingList.length === 2) {
        if (!this.showSpacingList.includes('right')) {
          map.left = 20
          map.center = 82
          document.getElementById('canvas-views').style = ''
        } else if (!this.showSpacingList.includes('center')) {
          map.left = 50
          map.right = 50
          document.getElementById('canvas-views').style = 'display:none'
        } else if (!this.showSpacingList.includes('left')) {
          map.center = 75
          map.right = 28
          document.getElementById('canvas-views').style = ''
        }
      } else if (this.showSpacingList.length === 1) {
        if (this.showSpacingList.includes('left')) {
          map.left = 100
          document.getElementById('canvas-views').style = 'display:none'
        } else if (this.showSpacingList.includes('center')) {
          map.center = 100
          document.getElementById('canvas-views').style = ''
        } else if (this.showSpacingList.includes('right')) {
          map.right = 100
          document.getElementById('canvas-views').style = 'display:none'
        }
      } else if (this.showSpacingList.length === 0) {
        document.getElementById('canvas-views').style = 'display:none'
      }
      return map
    },
    fullScreen() {
      let device = this.$refs.mainCardContent.$el
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        console.log('已还原！')
      } else {
        if (device.requestFullscreen) {
          device.requestFullscreen()
        } else if (device.webkitRequestFullScreen) {
          device.webkitRequestFullScreen()
        } else if (device.mozRequestFullScreen) {
          device.mozRequestFullScreen()
        } else if (device.msRequestFullscreen) {
          device.msRequestFullscreen()
        }
      }
    },

    handleCreated(callObj) {
      ztreeObj = callObj
      this.setModel()
    },
    ztreeOnCheck(ztreeObj, treeId, treeNode) {
      this.setModel()
    },
    async ztreeOnClick(ztreeObj, treeId, treeNode) {
      let uuuid = treeNode.id
      const structInfo = this.structInfoMap[uuuid]
        ? this.structInfoMap[uuuid]
        : {
          structId: uuuid,
          sceneId: this.sceneId
        }
      const { name } = uuidTreeNodeMap[uuuid]
      let form = {}
      Object.assign(form, { name })
      Object.assign(form, structInfo)
      this.form = form
      this.$refs.ThreeModel.setColor({
        object: uuidObject3DMap[uuuid]
      })
    },
    search() {
      ztreeObj.refresh()
      let nodeList = ztreeObj.getNodesByParamFuzzy('name', this.treeName) //模糊搜索
      if (nodeList[0]) {
        let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
        if (parentList[0]) {
          ztreeObj.expandNode(parentList[0], true, false, false)
        }
        this.$nextTick(() => {
          let dom = document.getElementById(nodeList[0].tId + '_a')
          if (dom) {
            dom.click()
          }
        })
      }
    },
    setClick(uuuid, model) {
      uuuid = uuuid || model.parent.uuuid
      // uuuid = uuuid || model.uuuid;
      let nodes = ztreeObj.getNodes()
      let setModel = (l) => {
        l.forEach((v) => {
          if (v.id === uuuid) {
            let tId = v.tId

            ztreeObj.refresh()

            let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
            if (nodeList[0]) {
              let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
              if (parentList[0]) {
                ztreeObj.expandNode(parentList[0], true, false, false)
              }
            }
            this.$nextTick(() => {
              let dom = document.getElementById(tId + '_a')
              if (dom) {
                dom.click()
              }
            })
            // ztreeObj.checkNode(v, true);
          }
          if (v.children && v.children.length !== 0) {
            setModel(v.children)
          }
        })
      }
      setModel(nodes)
    },
    async modelClick(model) {
      this.setClick('', model)
    },
    setModel() {
      let list = ztreeObj.getCheckedNodes(true)
      let idList = list.map((v) => v.id)
      let isShow = 1
      let checkList = []
      let setModel = (l, type) => {
        l.forEach((v) => {
          if (v.type === 'Mesh') return
          // if (isShow === 3) return;
          let index = idList.indexOf(v.uuuid)
          let map = null
          if (index > -1 && !type) {
            map = list[index].check_Child_State === 2
            if (list[index].check_Child_State === 2) {
              if (checkList.includes(list[index].level)) {
                isShow = 3
              } else {
                isShow = 2
                checkList.push(list[index].level)
              }
            }
            if (list[index].check_Child_State === -1) {
              if (checkList.includes(list[index].level)) {
                isShow = 3
              } else {
                isShow = 2
                checkList.push(list[index].level)
              }
            }
          }
          v.visible = idList.includes(v.uuuid)
          v.visible = v.uuuid === this.checkedSceneId + '.1.0' ? true : v.visible
          if (v.visible && v.children[0] && v.children[0].type === 'Mesh') {
            // this.checkedNodeList.push(v);
            v.children[0].visible = true
          }
          if (v.children && v.children.length !== 0) {
            setModel(v.children, type ? type : map ? 1 : 0)
          }
        })
      }
      setModel(this.$refs.ThreeModel.scenes)
      if (isShow !== 2) {
        // this.checkedNodeList = [];
      }
    },
    initThree() {
      let width = document.getElementById('canvas').clientWidth
      let height = document.getElementById('canvas').clientHeight
      return {
        width,
        height
      }
    },
    getTree(list, url) {
      let l = []
      console.log('树节点', list)
      uuidTreeNodeMap = {}
      uuidObject3DMap = {}
      function getTree(list, obj) {
        list.forEach((v) => {
          if (v.type === 'Mesh') return
          if (v.name) {
            const parseObj = {
              id: v.uuuid,
              pid: v.parent ? v.parent.uuuid : 0,
              name: v.name,
              open: false,
              checked: true,
              level: v.level
            }
            l.push(parseObj)
            uuidTreeNodeMap[v.uuuid] = parseObj
            uuidObject3DMap[v.uuuid] = v
          }
          if (v.children && v.children.length !== 0) {
            getTree(v.children, obj)
          }
        })
      }
      let obj = {}
      getTree(list, obj)
      this.treeDatas = l
      this.checkedNodeList = []
      this.checkedNodeList[0] = {
        uuuid: l[0].id,
        parent: {
          uuuid: l[0].pid
        },
        level: l[0].level,
        name: l[0].name
      }
      return l
    },
    setOldColor() {
      function setModel(list) {
        list.forEach((v) => {
          if (v.material) {
            v.material.color.copy(v.material.oldColor || v.material.color)
          }
          if (v.children && v.children.length !== 0) {
            setModel(v.children)
          }
        })
      }
      setModel(this.scenes)
    },
    async save() {
      this.$refs.basicInfoForm.submitBasicProperty('save')
      return true
    },

    handleOpenSceneConfirm(modObj) {
      this.sceneId = modObj._id
      this.showDialog = false
      this.checkScene(modObj)
      this.getStructInfo()
    },
    saveTree(structInfo) {
      const findNodeParentNode = (node, callNodeMap = {}) => {
        if (!node) {
          return ''
        }
        if (node && node.level > 1) {
          findNodeParentNode(uuidTreeNodeMap[node.pid], callNodeMap)
        }
        callNodeMap[node.id] = node
      }

      let nodeMap = {}
      for (let property in this.structInfoMap) {
        findNodeParentNode(uuidTreeNodeMap[property], nodeMap)
      }
      const tree = []
      for (let property in nodeMap) {
        let obj = nodeMap[property]
        obj.allowChoose = this.structInfoMap[property] === undefined
        tree.push(obj)
      }

      saveTreeData({
        sceneId: this.sceneId,
        treeArr: tree
      })

      this.structInfoMap[structInfo.structId] = structInfo
    },
    getStructInfo() {
      findStructAllInfo({ sceneId: this.sceneId, type: 'device' }).then((res) => {
        this.structInfoMap = res.data.reduce((pre, next) => {
          pre[next.structId] = next
          return pre
        }, {})
      })
    }
  },

  queriedData() {
    let result = this.tableData
    if (this.searchedData.length > 0) {
      result = this.searchedData
    }
    return result.slice(this.from, this.to)
  },
  to() {
    let highBound = this.from + this.pagination.perPage
    if (this.total < highBound) {
      highBound = this.total
    }
    return highBound
  },
  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1)
  },
  total() {
    return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length
  },
  mounted() {
    this.sceneId = '629dfc06d809c3365b8adf17'
    this.getStructInfo()
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ['name', 'email'],
      threshold: 0.3
    })
    document.addEventListener('fullscreenchange', () => {
      this.fullscreen = !this.fullscreen
    })
    document.addEventListener('mozfullscreenchange', () => {
      this.fullscreen = !this.fullscreen
    })
    document.addEventListener('webkitfullscreenchange', () => {
      this.fullscreen = !this.fullscreen
    })
    document.addEventListener('msfullscreenchange', () => {
      this.fullscreen = !this.fullscreen
    })
    this.init()
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    treeName() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.search()
      }, 1000)
    },
    searchQuery(value) {
      let result = this.tableData
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
    },
    async checkedNodeList() {
      if (this.checkedNodeList.length === 1) {
        // this.resetSize();
        this.form.id = ''
        // this.getPropertyListAll();
        this.getStructInfo()
      }
    }
  },
  beforeDestroy() { }
}
</script>

<style lang="css">
.v-card-header-icon .card-icon{
      background-color: #4caf50 !important;
    border-radius: 3px;
    padding: 10px 14px;
    margin-top: -60px;
    margin-right: 15px;
}
.v-card-header-icon .card-icon i{
     color: #fff;
}
.md-dialog-container {
  min-width: 50%;
  overflow: auto;
}

.md-dialog-container .md-field {
  display: block;
}

.img-txt {
  display: flex;
  place-items: flex-start;
}

.img-txt img {
  background: #efefef;
  padding: 10px;
  border-radius: 10px;
  width: 180px;
}

.img-txt span {
  line-height: 30px;
  margin-top: 10px;
  margin-left: 50px;
  color: #82bc79;
  font-size: x-small;
  font-weight: 400;
}

.md-field .md-textarea {
  padding: '7px 0px 5px 10px';
}

.meta-css .md-collapse-content {
  padding: 0;
}

.meta-css .md-card-content>.split {
  background: #fff;
  overflow: visible;
  display: flex;
}

.meta-css .md-card-content>.split>.split-horizontal:nth-child(3) {
  overflow: visible;
}

.meta-css .md-card-content>.split>.split-horizontal:first-child {
  overflow-x: auto;
}

.meta-css .checkbox_true_part {
  background: none !important;
  border: 1px solid #d7dde4 !important;
}

.meta-css .md-field.icon-field {
  overflow: hidden;
}

.structVersion-icon {
  cursor: pointer;
  color: #fff !important;
  margin: 0;
}

.meta-css img.icon {
  display: block;
  cursor: pointer;
  width: 200px;
  border: 1px solid #ccc;
  min-height: 100px;
  margin-top: 30px;
}

.meta-css ul.files {
  list-style: none;
}

.meta-css ul.files li {
  display: flex;
  justify-content: space-between;
}

.meta-css ul.files li span {
  cursor: pointer;
}

.canvas {
  height: 100%;
}

.meta-css .md-field {
  display: block;
  margin-bottom: 5px !important;
}

.meta-css .md-input {
  width: inherit !important;
}

.md-field .md-input {
  width: inherit !important;
}

.md-field .md-textarea {
  width: 100%;
  overflow: hidden;
}

.meta-css .md-toolbar {
  color: #808990 !important;
  padding: 1px 5px;
  border-radius: 1px;
  position: static;
  border-bottom: 1px solid rgb(0 0 0 / 3%);
}

.meta-css .md-tree {
  padding: 0px 0px;
}

.meta-css .md-collapse {
  padding-left: 15px;
}

.meta-css .span {
  min-width: 60px;
  margin: 30px;
  display: inline-block;
  text-align: center;
}

.meta-css .md-card {
  margin: 0px;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 14%);
}

.meta-css .md-card .md-card-actions {
  border-top: 0px;
}

.meta-css .md-icon-text-button {
  width: 80px;
}

.meta-css .md-dialog .md-dialog-container {
  padding: 30px;
  min-width: 650px;
  min-height: 650px;
}

/* .meta-css .md-field > .md-icon ~ label {
  padding-top: 21px;
} */
.meta-css .md-field label {
  position: static;
}

.meta-css.md-field:after,
.meta-css .md-field:before {
  bottom: 0px;
}

.meta-css .md-field .md-input,
.meta-css .md-field .md-textarea {
  height: 20px;
}

.window-card {
  box-shadow: 0 0px 0px 0 rgb(0 0 0 / 14%) !important;
}

.md-tabs-content table thead {
  display: table-header-group !important;
  font-size: xx-small !important;
  color: green;
}
</style>
